import { Box, Flex } from 'components/Box'
import styled from 'styled-components'
import { Text } from 'components/Text';
import Container from 'components/layout/Container';

export const DiamondStyle = styled(Flex)`
    justify-content: center;
    align-items: center;
    background: ${(props) => props.theme.colors.imgBackgroundColor};
    ${({ theme }) => theme.mediaQueries.xs} {
        flex-direction:row;
        width: 52px;
        height: 52px;
        border: 3px solid ${(props) => props.theme.colors.borderColor};
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        flex-direction:row;
        width: 90px;
        height: 90px;
        border: 5px solid ${(props) => props.theme.colors.borderColor};
    }
    ${({ theme }) => theme.mediaQueries.md} {
        border: 8px solid ${(props) => props.theme.colors.borderColor};
        flex-direction:column;
        height: 140px;
        width: 140px;
    }
`
export const DiamondStyleChecked = styled(DiamondStyle)`
    border: 8px solid ${(props) => props.theme.colors.primary};
`

export const WorkingTextStyle = styled(Text)`
    ${({ theme }) => theme.mediaQueries.xs} {
        padding-top: 20px;
        text-align: center;
        font-size: 12px;
        font-family: Avenir;
    } 
    ${({ theme }) => theme.mediaQueries.sm} {
        font-size: 20px;
        font-weight: 500;
    }
`
export const WorkingBoxStyle = styled(Flex)`
    ${({ theme }) => theme.mediaQueries.xs} {
        // display: block;
        justify-content: space-around;
        margin: 20px 0px 50px 0px;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        justify-content: space-around;
    }
    ${({ theme }) => theme.mediaQueries.md} {
        justify-content: center;
        margin: 50px 0px;
    }
`
export const OurGamesMobileBox = styled(Box)`
    ${({ theme }) => theme.mediaQueries.xs} {
        margin-right: 5px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        .CurrencyImg{
            width: 35px;
            height: 35px;
        }
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        .CurrencyImg{
            width: 50px;
            height: 50px;
        }
    }
    ${({ theme }) => theme.mediaQueries.md} {
        all: unset;
        margin-right: 40px;

        .CurrencyImg{
            width: 60px;
            height: 60px;
        }
    }
`
export const ContainerScrollingMargin = styled(Container)`
    scroll-margin-top: 45px;
    margin-top: -2px;
`
export const ArrowIconStyle = styled(Flex)`
    ${({ theme }) => theme.mediaQueries.xs} {
        display: none;
    } 
    ${({ theme }) => theme.mediaQueries.md} {
        display: block;
        margin-right:30px;
        justify-content: center;
        padding: 60px 0px;
    }
`
export const WorkInfoImages = styled(Box)`
    ${({ theme }) => theme.mediaQueries.xs} {
        margin-right: 0px;
    } 
    ${({ theme }) => theme.mediaQueries.md} {
        margin-right: 30px;
    }
`